import React from "react";
import TestApp from "./Tests";
import { Box, Typography } from "@mui/material";
import AnyTestComponent from "./AnyTestComponent";


const ReadingComponent = () => {
  return (
    <AnyTestComponent 
    questionCount={28} 
    title={'Reading Component'} 
    componentType={'reading'}
    >
    </AnyTestComponent>
  );
}

export default ReadingComponent;
